<!-- <button (click)='accessS3AndListFiles()'> Show Mahabharatham File List </button> -->
<br><br>
<div *ngFor="let entry of fileList">
    <div class="card">
        <a role="button" (click)="onClickMediaItem(entry)"> {{ entry.key }} </a>
    </div>
    <br>
    
    <!-- <button ng-click="onClickMediaItem(entry)">{{ entry.key }}</button> -->
</div>